import React from 'react'

import NoPermissionContainer from '@SonarCX/components/molecules/NoPermissionContainer'
import SettingsSection from '../../SettingsSection'
import PaymentSettings from '../PaymentSettings'
import PaymentCards from '../PaymentCards'
import SubscriptionSettings from '../SubscriptionSettings'
import SubscriptionCards from '../SubscriptionCards'
import InvoiceSettings from '../InvoiceSettings'
import InvoiceCards from '../InvoiceCards'

import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import { usePayment } from '@SonarCX/providers/PaymentProvider'
import { useSubscription } from '@SonarCX/providers/SubscriptionProvider'
import { useInvoice } from '@SonarCX/providers/InvoiceProvider'

const SettingsSections: React.FC = () => {
  const { isExtraSmall } = useBreakpoint()
  const { loaded: paymentsLoaded, error: paymentsError } = usePayment()
  const { loaded: subscriptionsLoaded, error: subscriptionsError } =
    useSubscription()
  const { loaded: invoicesLoaded, error: invoicesError } = useInvoice()

  return (
    <>
      <NoPermissionContainer skipAgentPage error={paymentsError}>
        <SettingsSection title='Payment Methods' loaded={paymentsLoaded}>
          {isExtraSmall ? <PaymentCards /> : <PaymentSettings />}
        </SettingsSection>
      </NoPermissionContainer>

      <NoPermissionContainer skipAgentPage error={subscriptionsError}>
        <SettingsSection title='Subscription' loaded={subscriptionsLoaded}>
          {isExtraSmall ? <SubscriptionCards /> : <SubscriptionSettings />}
        </SettingsSection>
      </NoPermissionContainer>

      <NoPermissionContainer skipAgentPage error={invoicesError}>
        <SettingsSection title='Invoices' loaded={invoicesLoaded}>
          {isExtraSmall ? <InvoiceCards /> : <InvoiceSettings />}
        </SettingsSection>
      </NoPermissionContainer>
    </>
  )
}

export default SettingsSections
